import { commitMutation, graphql } from "react-relay";
import environment from "../../Network";

const mutation = graphql`
  mutation UpdateUserMessagingTokenMutation($token: String!) {
    updateUserMessagingToken(token: $token) {
      ok
    }
  }
`;

export default (token, successCallback, validationErrorsCallback) => {
  const variables = {
    token,
  };

  commitMutation(environment, {
    mutation,
    variables,
    onError: (err) => console.error(err),
    updater: (proxyStore) => {
      const updateUserField = proxyStore.getRootField(
        "updateUserMessagingToken"
      );
      const ok = updateUserField.getValue("ok");
      if (!ok) {
        console.error("Cannot update user messaging token");
      }
    },
  });
};



// WEBPACK FOOTER //
// ./src/mutations/users/UpdateUserMessagingTokenMutation.js